(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vv-selection"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('vv-product-carousel'))customElements.define('vv-product-carousel',class extends HTMLElement{connectedCallback(){this.controller=new AbortController();const signal=this.controller.signal;const category=new URLSearchParams(location.search).get('tipo');const cards=[...this.querySelectorAll('article')];cards.forEach(card=>{const type=(card.dataset.vvCategory||'').toLowerCase();const groups={Giacche:['giacche','blazer','giacche e blazer'],Completi:['completi','tute'],Maglieria:['maglieria','cardigan','maglieria e cardigan']};const matches=groups[category]?groups[category].includes(type):type===(category||'').toLowerCase();card.hidden=Boolean(category&&!matches);});const visible=cards.filter(card=>!card.hidden);this.hidden=Boolean(category&&!visible.length);this.querySelector('.vv-selection__empty').hidden=visible.length>0;const grid=this.querySelector('.vv-selection__grid'),prev=this.querySelector('[data-vv-prev]'),next=this.querySelector('[data-vv-next]'),count=this.querySelector('output');if(!prev||!next)return;const refresh=()=>{if(!visible.length){prev.disabled=true;next.disabled=true;count.textContent='0 / 0';return;}const bounds=grid.getBoundingClientRect();const inView=visible.map((card,index)=>({box:card.getBoundingClientRect(),index})).filter(x=>x.box.right>bounds.left+3&&x.box.left<bounds.right-3);prev.disabled=grid.scrollLeft<2;next.disabled=grid.scrollLeft+grid.clientWidth>=grid.scrollWidth-3;if(inView.length)count.textContent=(inView[0].index+1)+'–'+(inView.at(-1).index+1)+' / '+visible.length;};const move=direction=>grid.scrollBy({left:direction*grid.clientWidth*.92,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});prev.addEventListener('click',()=>move(-1),{signal});next.addEventListener('click',()=>move(1),{signal});grid.addEventListener('scroll',refresh,{passive:true,signal});this.observer=new ResizeObserver(refresh);this.observer.observe(grid);refresh();}disconnectedCallback(){this.controller?.abort();this.observer?.disconnect();}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vv-style-gallery"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('vv-style-gallery'))customElements.define('vv-style-gallery',class extends HTMLElement{connectedCallback(){this.controller=new AbortController();const signal=this.controller.signal;const track=this.querySelector('.vv-style__track'),prev=this.querySelector('[data-style-prev]'),next=this.querySelector('[data-style-next]'),count=this.querySelector('output');if(!track)return;const refresh=()=>{const cards=[...track.children];if(!cards.length)return;const width=cards[0].getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap||0);const index=Math.min(cards.length,Math.round(track.scrollLeft/width)+1);prev.disabled=track.scrollLeft<2;next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-3;count.textContent=index+' / '+cards.length;};const move=dir=>{const card=track.querySelector('figure');if(card)track.scrollBy({left:dir*(card.getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap||0)),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});};prev.addEventListener('click',()=>move(-1),{signal});next.addEventListener('click',()=>move(1),{signal});track.addEventListener('scroll',refresh,{passive:true,signal});this.observer=new ResizeObserver(refresh);this.observer.observe(track);refresh();}disconnectedCallback(){this.controller?.abort();this.observer?.disconnect();}});

  } catch(e) { console.error(e); }
})();
})();
